import { render, staticRenderFns } from "./KitItens.vue?vue&type=template&id=2e0bf5b0"
import script from "./KitItens.vue?vue&type=script&lang=js"
export * from "./KitItens.vue?vue&type=script&lang=js"
import style0 from "./KitItens.vue?vue&type=style&index=0&id=2e0bf5b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports